import styled from 'styled-components/macro';

export const StyledAllEventsItem = styled.div`
  &:not(:last-child) {
    margin-bottom: 1.6rem;
  }
  .text-right {
    text-align: right;
  }
  .card-head {
    @media (max-width: 500px) {
      display: block !important;
    }
  }
  .event-name-cell {
    flex: 0 0 auto;
    width: 300px;
  }
  .event-date-cell {
    flex: 0 0 auto;
    width: 150px;
  }
`;

export const StyledDateTab = styled.div`
  position: sticky;
  background: ${(props) => props.theme.white};
  padding-bottom: 10px;
  top: 0;
`;
